import { useContext } from "react";
import { WplywContext } from "../../../../context/wplywContext";
import {
	buildPrzekazTitlePreview,
	TRANSFER_TITLE_MAX_LENGTH,
} from "../../../../components/transferTitleUtils";

const useStage1 = () => {
	const { wplyw } = useContext(WplywContext);
	if (!wplyw?.wplyw_data) return false;

	const data = wplyw.wplyw_data.data.msr_wplywy || {};

	// Check conditions
	const isBankAccountIdSet = data.msr_wplywy_bank_accounts_id !== null;
	const isPrimaryAmountValid =
		!isNaN(parseFloat(data.msr_wplywy_primary_amount)) &&
		data.msr_wplywy_primary_amount != "";
	const isPrimaryDeductionValid = data.msr_wplywy_primary_deduction >= 0;
	const isToForward = Number(data.msr_wplywy_to_forward || 0) === 1;
	const isToForwardReady =
		Number(data.msr_wplywy_to_forward_ready || 0) === 1;
	const hasForwardDate = Boolean(
		data.msr_wplywy_date_forward &&
		String(data.msr_wplywy_date_forward) !== "null",
	);
	const transferTitleText = String(
		data.msr_wplywy_przekaz_title_text ?? data.msr_wplywy_bank_desc ?? "",
	);
	const transferTitlePreview = buildPrzekazTitlePreview(transferTitleText);
	const isTransferTitleWithinLimit =
		!isToForward ||
		transferTitlePreview.length <= TRANSFER_TITLE_MAX_LENGTH;
	const isDateInSet = !!data.msr_wplywy_date_in;
	const isDescBank = data.msr_wplywy_bank_desc;
	return (
		isBankAccountIdSet &&
		isPrimaryAmountValid &&
		isPrimaryDeductionValid &&
		(!isToForward || (hasForwardDate && isToForwardReady)) &&
		isTransferTitleWithinLimit &&
		isDateInSet &&
		isDescBank
	);
};

export default useStage1;
